import type { ModuleInfo } from '../../src/BinaryReader';

// DWARF binding and consumption (function/parameter/local names, struct fields) live in
// the core library (src/decompiler/DwarfNaming.ts); only these display helpers remain here.

export function getDwarfLanguageName(language: number): string {
  const languageNames: Record<number, string> = {
    0x01: 'C89', 0x02: 'C', 0x04: 'C++', 0x0c: 'C99',
    0x1a: 'C11', 0x2a: 'C17', 0x1c: 'C++03', 0x21: 'C++11',
    0x22: 'C++14', 0x1d: 'Rust',
    0x12: 'Java', 0x0e: 'Python', 0x1f: 'Swift',
    0x24: 'Kotlin', 0x20: 'Go', 0x25: 'Zig',
  };
  return languageNames[language] || `language_${language} (0x${language.toString(16)})`;
}

export function getNameSource(
  globalFuncIndex: number,
  moduleInfo: ModuleInfo | null,
  dwarfFunctionMap: Map<number, string> | null,
): string | null {
  if (moduleInfo?.nameSection?.functionNames?.has(globalFuncIndex)) {
    return 'WASM name section';
  }
  if (dwarfFunctionMap && dwarfFunctionMap.has(globalFuncIndex)) {
    return 'DWARF debug info';
  }
  return null;
}
